export const videoPlaceholder = {
  backgroundColor: "#ccc",
  backgroundImage:
    'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAABaklEQVR42u3bIU7DcBTA4YWQIDAYFI4TECwGg+cIOLAEJIIDwCUaxNamGaoCxBBguQEOzwkYvJItWaYJfR3flzzbpvll7dr+OxgAAAAAAAAAAAAAACuvLMuvVR1BBBFEEEEE+fdBqqq6Go1Gxz2a81UPctizY9gTRJD+BIltnDRNsyFIniBPMa91Xe8KkidIu61pe9EVpOsgVfmxuL2IcjOZTNYFSRJkNs8xO4LkCdLOZ8yRIHmC/ESJU9h1WBMkR5D5PMRsC5InSDvv8Ws5ECRPkPn+LgRJFGQ29+PxeEuQPEHaeRsOh/uC5AnS7nsacypIkiALd/d3RVFsCpIkyGwqQfxCBFm+hkSMM9cQ/7IEcR+SNEicoi7dqXuWJcjSPHramyOI9yGJgnhjmCjIi3fqeYLcWnXSZRDrslIGsXIxURBrezMF6eAYBBHkb4P4gipTEN8YCiKIIIIIIggAAAAAAAAAAAAA/KpvIMhShRPBqAoAAAAASUVORK5CYII=")',
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  boxShadow: "0 0 0 2px #999",
  opacity: 0.5,
  width: "100%"
}
